import { makeSx } from '../../../theme/_utils'
import { defaultPalette } from '../../../theme/idsTheme'
import { hexToRgba } from '../../../utils/commonUtils'

export default makeSx({
    HealthCareServicesListItemActive: {
        '& .MuiTypography-root': {
            color: defaultPalette.typography.light,
        },
    },
    HealthCareServicesListTextField: {
        width: '100%',
    },
    HealthCareServicesListContainer: {
        overflow: 'hidden',
        flex: 1,
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
    },
    HealthCareServicesList: {
        overflow: 'auto',
        flex: 1,
        maxHeight: '70dvh',
    },
    HealthCareServicesListScrollable: {
        background: defaultPalette.lightGrey.main,
        border: `1px solid ${defaultPalette.lightGrey.half}`,
        borderRadius: '1rem',
        marginTop: '.5rem',
    },
    HealthCareServicesListItemInnerContainer: {
        padding: '1rem 1.2rem',
        borderRadius: '1rem',
        background: hexToRgba(defaultPalette.typography.grey, 0.05),
        border: `1px solid ${hexToRgba(defaultPalette.typography.grey, 0.05)}`,
        display: 'flex',
        alignItems: 'center',
        gap: '1rem',
        marginBottom: '1rem',
    },
    HealthCareServicesListItemInnerContainerIcon: {
        fill: defaultPalette.typography.grey,
    },
    HealthCareServicesListItemInnerContainerText: {
        fontSize: '.85rem',
        color: defaultPalette.typography.grey,
    },
    HealthCareServicesListButtonContainer: {
        paddingTop: '2rem',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    HealthCareServicesListScrollButtonContainer: {
        position: 'absolute',
        bottom: '.5rem',
        left: 0,
        display: 'flex',
        justifyContent: 'center',
        zIndex: 500,
        width: '100%',
    },
    HealthCareServicesListScrollButton: {
        background: defaultPalette.lightGrey.light,
        border: `1px solid ${defaultPalette.lightGrey.dark}`,
        padding: '.5rem',
        '& svg': {
            width: '1rem',
            height: '1rem',
        },
    },
})
